import React from 'react';
import { connect } from 'react-redux';

import OptionsSet from '../optionsSet.js';
import ExtraFilters from '../extraFilters/extraFilters.js';
import { _ } from '../../../functions/translator.js';

class FilterTab extends React.Component {

    render() {
        return(
            <div
                role="tabpanel"
                hidden={this.props.tabIndex !== this.props.index}
                className='pb-2'
                >
                <p>{_('Filtros')}:</p>
                <OptionsSet/>
                <ExtraFilters/>
            </div>
        );
    } 
}

function mapStateToProps( state ){
    return { 
        menu: state.switches.menu,
    }
}

export default connect(mapStateToProps)(FilterTab);